(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    /* Open */
    document.querySelectorAll('[data-cart-open]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });

    /* Close */
    document.querySelectorAll('[data-cart-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        closeDrawer();
      });
    });

    /* Keyboard: Escape closes, Tab is trapped inside the open drawer */
    var lastFocused = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

    document.addEventListener('keydown', function(e) {
      if (!drawer.hasAttribute('data-open')) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function(el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    function openDrawer() {
      lastFocused = document.activeElement;
      drawer.removeAttribute('hidden');
      drawer.offsetHeight; /* reflow */
      drawer.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('.cart-drawer__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.removeAttribute('data-open');
      document.body.style.overflow = '';
      setTimeout(function() {
        drawer.setAttribute('hidden', '');
      }, 300);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    /* Quantity buttons */
    drawer.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-qty-minus');
        var display = drawer.querySelector('[data-qty-value="' + key + '"]');
        var qty = parseInt(display.textContent, 10);
        updateItem(key, Math.max(0, qty - 1));
      });
    });

    drawer.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-qty-plus');
        var display = drawer.querySelector('[data-qty-value="' + key + '"]');
        var qty = parseInt(display.textContent, 10);
        updateItem(key, qty + 1);
      });
    });

    /* Remove buttons */
    drawer.querySelectorAll('[data-remove-item]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-remove-item');
        updateItem(key, 0);
      });
    });

    function updateItem(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        window.location.reload();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
